import {NEW_CAR, NOT_DEFINED, RENTAL} from "./FuelsConstants";
import { useTranslation } from "react-i18next";


export const useFuelCategories = () => {

    const {t} = useTranslation(['finance'], {keyPrefix: 'fuel.filters.categories'});


    const getCategories = (status: string) => {
        switch (status) {

            case RENTAL:        return t('RENTAL');
            case NEW_CAR:      return t('NEW_CAR');
            case NOT_DEFINED:      return t('NOT_DEFINED');

            default : return '-'
        }
    };

    return {
        getCategories
    }
}